import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100%;
  flex: 1;
  
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  
  * {
    margin-top: 10px;
  }
`
